import classNames from 'classnames';
import { MdCheckCircle, MdOutlineClose, MdOutlineHighlightOff } from 'react-icons/md';
import useToast from '../../../core/hooks/useToast';
import { ToastContent, ToastContentLevel } from '../../../core/toast/slice';
import ContentWrapper from '../ContentWrapper';

type Props = {
  toast: ToastContent;
};

const renderIcon = (level: ToastContentLevel) => {
  switch (level) {
    case 'success':
      return <MdCheckCircle size="20px" className="text-green-600" />;
    case 'error':
      return <MdOutlineHighlightOff size="20px" className="text-red-700" />;
    default:
      throw new Error(`Unexpected value!! ${level}`);
  }
};

const Toast: React.FC<Props> = (props) => {
  const {
    toast: { id, content, level },
  } = props;
  const { removeToast } = useToast();

  setTimeout(() => {
    removeToast(id);
  }, 10000);

  const isSuccess = level === 'success';
  const isError = level === 'error';

  return (
    <div
      className={classNames('mt-0  drop-shadow-md', {
        'bg-green-50': isSuccess,
        'bg-red-100': isError,
      })}
    >
      <ContentWrapper>
        <div className="flex h-12 w-auto items-center justify-between sm:h-14">
          <div className="flex items-center">
            {renderIcon(level)}
            <p
              className={classNames('pl-3', {
                'text-green-800': isSuccess,
                'text-red-800': isError,
              })}
            >
              {content}
            </p>
          </div>
          <button type="button" onClick={() => removeToast(id)}>
            <MdOutlineClose
              size="20px"
              className={classNames({ 'text-green-800': isSuccess, 'text-red-800': isError })}
            />
          </button>
        </div>
      </ContentWrapper>
    </div>
  );
};

export default Toast;
